import { GeekRewardingRequestData, RequestStatus, GeekRewardingRequest} from '@/models/reward-geek';

export function groupBy(xs: any, key: any) {
  return xs.reduce((rv: any, x: any) => {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
}

export function containsAllFrom(checked: any[], target: any[]): boolean {
  return checked.every((i: any) => target.includes(i));
}

export function computeRewardOptions(percentValues: number[], max: number) {
  return [...new Set(percentValues.map(v => Math.ceil((v * max) * 0.01)))];
}

export function setCollapseIfPending(requests: GeekRewardingRequestData): GeekRewardingRequest[] {
  return requests.data.map(r => ({ ...r, collapsed: r.status === RequestStatus.Pending }));
}
